export default {
    title: '<strong>以下の内容を確認し、同意します。</strong>',
    termsAndConditions: {
        label: '利用規約の確認',
        description: `・<strong>個数確認</strong>：カウンターにて預け入れる荷物の総数を確認しました。表示されている個数に相違ありません。
・<strong>免責物品の確認</strong>：荷物の中に、PC・カメラ等の精密機器、ガラス・酒類等の壊れ物、現金・パスポート等の貴重品は入っていません。これらが破損・紛失しても補償されないことに同意します。
・<strong>補償上限と外装</strong>：補償上限額は1個あたり30万円までであること、およびスーツケース外装の軽微な傷・汚れ・キャスターの摩耗は免責であることに同意します。
・<strong>申出期限</strong>：荷物の破損等は、ホテルでの受取後24時間以内に申告する必要があることを理解しました。24時間を過ぎた申告は無効となることに同意します。
・<strong>違約金と規約</strong>：宿泊予約がない等の不正利用時には30,000円の違約金が発生すること、およびその他の利用規約全文に同意します。`,
    },
    // 預け入れ画面用の確認項目
    passportNotInside: {
        label: 'パスポート確認',
        description: '<strong>パスポートは入っていません</strong>',
    },
    counterVerification: {
        label: '受付確認',
        description: 'カウンターにて最終個数を確認しました',
    },
    // 確認画面用の確認項目（5つの個別チェックボックス）
    itemCountConfirmation: {
        label: '個数確認',
        description: 'カウンターにて預け入れる荷物の総数を確認しました。表示されている個数に相違ありません。',
    },
    liabilityExclusion: {
        label: '免責物品の確認',
        description:
            '荷物の中に、<strong>PC・カメラ等の精密機器、ガラス・酒類等の壊れ物、現金・パスポート等の貴重品</strong>は入っていません。これらが破損・紛失しても補償されないことに同意します。',
    },
    compensationLimit: {
        label: '補償上限と外装',
        description:
            '補償上限額は<strong>1個あたり30万円まで</strong>であること、および<strong>スーツケース外装の軽微な傷・汚れ・キャスターの摩耗</strong>は免責であることに同意します。',
    },
    claimDeadline: {
        label: '申出期限',
        description:
            '荷物の破損等は、ホテルでの<strong>受取後24時間以内</strong>に申告する必要があることを理解しました。24時間を過ぎた申告は無効となることに同意します。',
    },
    penaltyAndTerms: {
        label: '違約金と規約',
        description:
            '宿泊予約がない等の不正利用時には<strong>30,000円の違約金</strong>が発生すること、およびその他の[利用規約全文]に同意します。',
    },
};
